<template>
  <header id="page-header">
    <!-- Header Content -->
    <div class="content-header">
      <!-- Left Section -->
      <div>
        <!-- Toggle Sidebar -->
        <b-btn @click="toggleSidebar" variant="primary" class="mr-1">
          <i class="fa fa-fw fa-bars"></i>
        </b-btn>
        <!-- END Toggle Sidebar -->

        <!-- Open Search Section -->
        <button @click="toggleSearch" v-if="['NetworkGraphHome', 'NetworkGraphNetwork', 'AccountProfileHome', 'AccountProfileResults'].includes($route.name)" type="button" class="btn btn-primary mr-1">
          <i class="fa fa-fw fa-search"></i> <span class="ml-2 d-none d-md-inline-block">{{ $t('layout.pageHeader.search') }}</span>
        </button>
        <!-- END Open Search Section -->

        <!-- Open Filter Section -->
        <button @click="toggleSideOverlay" v-if="['NetworkGraphHome', 'NetworkGraphNetwork'].includes($route.name)" type="button" class="btn btn-primary mr-1" data-toggle="layout" data-action="side_overlay_toggle">
          <i class="fa fa-fw fa-filter"></i> <span class="ml-2 d-none d-md-inline-block">{{ $t('layout.pageHeader.filter') }}</span>
        </button>
        <!-- END Open Filter Section -->

        <!-- Toggle Network Physics -->
        <button v-if="['NetworkGraphNetwork'].includes($route.name)" @click="$store.commit('toggleNetworkPhysics')" type="button" class="btn btn-primary mr-1" >
          <font-awesome-icon v-if="physics" icon="toggle-on"/><font-awesome-icon v-else icon="toggle-off"/> <span class="ml-2 d-none d-md-inline-block">{{ $t('layout.pageHeader.physics') }}</span>
        </button>
        <!-- END Toggle Network Physics -->

        <!-- Toggle Network Settings -->
        <button v-if="['NetworkGraphNetwork'].includes($route.name)" @click="$store.commit('toggleShowSettings')" type="button" class="btn btn-primary mr-1" >
          <font-awesome-icon icon="cog" class="fa-fw"/> <span class="ml-2 d-none d-md-inline-block">{{ $t('layout.pageHeader.settings') }}</span>
        </button>
        <!-- END Toggle Network Settings -->
      </div>
      <!-- END Left Section -->

      <!-- Right Section -->
      <div>
        <!-- Change Chain -->
        <b-dropdown right variant="dual" no-caret class="mr-1">
          <template slot="button-content">
            <img :src="require('@/assets/_img/' + selectedChain + '-logo.png')" alt="Blockchain Logo" height="23"> <span class="ml-1 d-none d-md-inline-block text-uppercase">{{ selectedChain }}</span>
          </template>
          <b-dropdown-item @click="changeChain('eos')" :active="selectedChain === 'eos'"><img src="@/assets/_img/eos-logo.png" alt="EOS Mainnet" height="23" class="mr-1"> EOS</b-dropdown-item>
          <b-dropdown-item @click="changeChain('wax')" :active="selectedChain === 'wax'"><img src="@/assets/_img/wax-logo.webp" alt="WAX Mainnet" height="23" class="mr-1"> WAX</b-dropdown-item>
         <!-- <b-dropdown-item @click="changeChain('bos')" :active="selectedChain === 'bos'"><img src="@/assets/_img/bos-logo.png" alt="BOS Mainnet" height="23" class="mr-1"> BOS</b-dropdown-item>-->
        </b-dropdown>
        <!-- END Change Chain -->

        <!-- Change Language -->
        <b-dropdown right variant="dual" no-caret>
          <template v-if="selectedLanguage === 'en'" slot="button-content">
            <font-awesome-icon icon="globe-americas" class="fa-fw"/> <span class="ml-2 d-none d-md-inline-block text-uppercase">EN</span>
          </template>
          <template v-else slot="button-content">
            <font-awesome-icon icon="globe-asia" class="fa-fw"/> <span class="ml-2 d-none d-md-inline-block">{{ $t('layout.pageHeader.chinese') }}</span>
          </template>
          <b-dropdown-item @click="changeLang('en')" :active="selectedLanguage === 'en'"><font-awesome-icon icon="globe-americas" class="fa-fw mr-2"/> {{ $t('layout.pageHeader.english') }}</b-dropdown-item>
          <b-dropdown-item @click="changeLang('zh')" :active="selectedLanguage === 'zh'"><font-awesome-icon icon="globe-asia" class="fa-fw mr-2"/> {{ $t('layout.pageHeader.chinese') }}</b-dropdown-item>
        </b-dropdown>
        <!-- END Change Language -->
      </div>
      <!-- END Right Section -->
    </div>
    <!-- END Header Content -->

    <!-- Header Search -->
    <div id="page-header-search" class="overlay-header bg-primary" :class="{ 'show': showHeaderSearch }">
      <div class="content-header">
        <form v-on:submit.prevent="getResults()" class="w-100">
          <div class="input-group">
            <div class="input-group-prepend">
              <button @click="toggleSearch" type="button" class="btn btn-primary">
                <i class="fa fa-fw fa-times-circle"></i>
              </button>
            </div>
            <input v-model="search" @keydown.esc="toggleSearch" type="text" class="form-control border-0" :placeholder="$t('layout.pageHeader.enterAccount')" id="page-header-search-input" name="page-header-search-input">
          </div>
        </form>
      </div>
    </div>
    <!-- END Header Search -->

    <!-- Header Loader -->
    <div id="page-header-loader" class="overlay-header bg-primary" :class="{ 'show': isLoading }">
      <div class="content-header">
        <div class="w-100 text-center">
          <i class="fa fa-fw fa-2x fa-sun fa-spin text-white"></i>
        </div>
      </div>
    </div>
    <!-- END Header Loader -->
  </header>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'pageHeader',
  computed: {
    selectedLanguage () {
      return this.$store.state.options.selectedLanguage
    },
    selectedChain () {
      return this.$store.state.options.selectedChain
    },
    showHeaderSearch () {
      return this.$store.state.options.showHeaderSearch
    },
    search: {
      // getter
      get () {
        return this.$store.state.filter.search
      },
      // setter
      set (value) {
        this.$store.commit('setSearch', value)
      }
    },
    physics () {
      return this.$store.state.network.networkPhysics.enabled
    },
    isLoading () {
      return this.$store.state.options.isLoading
    },
    filters () {
      return this.$store.state.filter.filters
    },
    accountProfile () {
      return this.$store.state.profile.accountProfileResults
    }
  },
  methods: {
    ...mapMutations([
      'changeLanguage',
      'toggleSearch',
      'toggleSidebar',
      'toggleSideOverlay'
    ]),
    changeLang (lang) {
      this.changeLanguage(lang)
    },
    changeChain (chain) {
      if (this.selectedChain !== chain) {
        if (chain === 'bos') {
          window.location.href = 'https://bos.eosdetective.io' + this.$router.currentRoute.fullPath
        }
        if (chain === 'eos') {
          window.location.href = 'https://eosdetective.io' + this.$router.currentRoute.fullPath
        }
        if (chain === 'wax') {
          window.location.href = 'https://waxdetective.io' + this.$router.currentRoute.fullPath
        }
      }
    },
    getResults () {
      if (['NetworkGraphHome', 'NetworkGraphNetwork'].includes(this.$route.name)) {
        this.getNetworkResults()
      } else if (['AccountProfileHome', 'AccountProfileResults'].includes(this.$route.name)) {
        this.getProfileScoreResults()
      }
      this.toggleSearch()
    },
    getNetworkResults () {
      this.$store.dispatch('addAccounts', { accounts: this.search.split('-'), reset: true })
      this.$store.dispatch('loadNetworkGraphData')
      this.$router.push({
        name: 'NetworkGraphNetwork',
        query: this.$store.getters.getRouteParams
      })
    },
    getProfileScoreResults () {
      this.$store.commit('resetAccountProfile')
      this.$store.dispatch('loadAccountProfile')
      this.$router.push({
        name: 'AccountProfileResults',
        params: { account: this.search }
      })
    }
  }
}
</script>

<style scoped lang="scss">

</style>
